import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
 import { makeStyles } from '@material-ui/styles';
 import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {
  Button,
  Card,
  Avatar,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors
} from '@material-ui/core';

import { Label,  TableEditBar } from '../../../../components';

const useStyles = makeStyles(theme => ({
  root: {},
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0
  },
  inner: {
   // minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  }
}));

const Results = props => {
  const { className, orders,onPageChange,onPageLimit, ...rest } = props;

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [showpreview, setShowpreview] = useState(false);
  const [previewurl, setpreviewurl] = useState('');

  const handleSelectAll = event => {
    const selectedOrders = event.target.checked
      ? orders.map(order => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };

  const handleChangePage = (event, page) => {
    setPage(page);
    onPageChange(page)
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
    onPageLimit(event.target.value)
  };
  function previewimage(url)
  {
    setpreviewurl(url)
    setShowpreview(true)
  }
  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    active: colors.green[600],
    inactive: colors.red[600]
  };


  return (
    <>
    {showpreview && (
          <Lightbox
            mainSrc={previewurl}
           // nextSrc={images[(photoIndex + 1) % images.length]}
           // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setShowpreview(false)}
            onMovePrevRequest={() =>
              alert('prev')
            }
            onMoveNextRequest={() =>
              alert('next')
            }
          />
        )}
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
     
      <Card>
        <CardHeader
          
          title="ADs"
        />
        <Divider />
        <CardContent className={classes.content}>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    {/* <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedOrders.length === orders.length}
                        color="primary"
                        indeterminate={
                          selectedOrders.length > 0 &&
                          selectedOrders.length < orders.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell> */}
                    <TableCell>S no</TableCell>
                    <TableCell>Ad Image</TableCell>
                    <TableCell>Url</TableCell>
                    <TableCell>Commodity</TableCell>
                    <TableCell>Sub Commodity</TableCell>
                    {/* <TableCell>Language</TableCell> */}
                    <TableCell>Module Type</TableCell>
                    <TableCell>Priority</TableCell>
                    <TableCell>Ad type</TableCell>
                    <TableCell>Schedule</TableCell>
                    <TableCell>status</TableCell>
                    <TableCell>CreatedAt</TableCell>
                    <TableCell align="center">Edit</TableCell>
                    {/* <TableCell align="center">View</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders.slice(0, rowsPerPage).map((order,index) => (
                    <TableRow
                      key={order.id}
                      selected={selectedOrders.indexOf(order.id) !== -1}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedOrders.indexOf(order.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, order.id)}
                          value={selectedOrders.indexOf(order.id) !== -1}
                        />
                      </TableCell> */}
                      <TableCell>
                      {(page * rowsPerPage)+(index+1)}
                        
                      </TableCell>

                      <TableCell>
                        
                        <Avatar alt={order.title} src={order.imageurl} onClick={() => previewimage(order.imageurl)} />
                      </TableCell>
                      <TableCell>{order.ads_url}</TableCell>
                      
                      <TableCell>
                          <Label
                          color={paymentStatusColors['canceled']}
                          variant="contained"
                        >
                          {order?.parentcommodity?.name}
                        </Label>
                     </TableCell>
                      <TableCell>
                          <Label
                          color={paymentStatusColors['canceled']}
                          variant="contained"
                        >
                          {order?.subcommodity?.name}
                        </Label>
                     </TableCell>
                      <TableCell>{order.module}</TableCell>
                      <TableCell>{order.priority}</TableCell>
                      <TableCell>{order.adtype}</TableCell>
                      <TableCell>
                        {(order.schedule_mode === 'period' && order.start_at && order.end_at)
                          ? `${moment(order.start_at).format('DD MMM YY HH:mm')} – ${moment(order.end_at).format('DD MMM YY HH:mm')}`
                          : 'All time'}
                      </TableCell>
                      
                      <TableCell>
                         <Label
                          color={paymentStatusColors[order.status ? 'active' : 'inactive']}
                          variant="contained"
                        >
                          {order.status ? 'Active' : 'In Active'}
                        </Label>

                      </TableCell>
                      <TableCell>
                      <Typography variant="body1">
                          {moment(order.createdAt).format(
                            'DD MMM YYYY | hh:mm a'
                          )}
                        </Typography>
                      </TableCell>
                     
                      <TableCell align="center">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={`/editad/${order.id}`}
                          variant="outlined"
                          // to={`/editsurvey/${order.id}`}
                        >
                          Edit
                        </Button>
                      </TableCell>
                      {/* <TableCell align="center">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={`/editad/${order.id}`}
                          variant="outlined"
                        >
                         View
                        </Button>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={props.totalcount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25,100]}
          />
        </CardActions>
      </Card>
      <TableEditBar selected={selectedOrders} />
    </div>
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  onPageChange: PropTypes.func,
  onPageLimit : PropTypes.func
};

Results.defaultProps = {
  orders: []
};

export default Results;
